import { z } from 'zod';

import {
  PAYMENT_PLAN_FIELD_LABELS,
  paymentPlanFormSchema,
} from '#/modules/srmMgmt/purchaseOrder/schemas/paymentPlanFormSchema';

import {
  MISC_PURCHASE_ORDER_FIELD_LABELS,
  miscPurchaseOrderFormSchema,
} from './miscPurchaseOrderSchema';

export const miscPurchaseOrderAmendmentSchema = miscPurchaseOrderFormSchema.pick({
  taxType: true,
  roundingMode: true,
  issueReason: true,
  remark: true,
  lines: true,
}).extend({
  issueReason: z.string().trim().min(1, '請填寫異動事由'),
  paymentPlan: paymentPlanFormSchema,
});

export const MISC_PURCHASE_ORDER_AMENDMENT_FIELD_LABELS = {
  ...MISC_PURCHASE_ORDER_FIELD_LABELS,
  issueReason: '異動事由',
  ...PAYMENT_PLAN_FIELD_LABELS,
};
